angular.module("questionarioAdv.module")
    .component("modalitaFirmaNuovaAdv", {
        templateUrl: 'ng/components/questionarioAdv/modalitaFirmaNuovaAdv/modalitaFirmaNuovaAdv.html',
        bindings: {
            model: '=',
            firmaChanged: '&',
            exportValidationComponent: '&',
        },
        controller: modalitaFirmaNuovaAdv,
        controllerAs: "modalitaFirmaAdvCtrl"
    })

function modalitaFirmaNuovaAdv(
    $scope,
    $rootScope,
    $timeout
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            firmaDigitale: {
                selected: false
            }
        }
        self.supportModel.firmaDigitale.selected = self.model.firmaDigitale;
        self.firmaChanged();

        if(self.supportModel.firmaDigitale.selected == true) {
            self.supportModel.firmaDigitalePersonale = false;
        } else {
            self.supportModel.firmaDigitalePersonale = true;
        }
        
        validateComponent();
        $timeout(function () {
            self.validatingComponent();
        }, 200)
    }
    
    self.check = function (el) {
        el.selected = !el.selected;
        self.model.firmaDigitale = el.selected;
        self.firmaChanged();
    }

    self.radioModify = function (tipo, valore) {
        if (tipo == 'firmaDigitalePersonale') {
            self.supportModel.firmaDigitale.selected = !valore;
            self.model.firmaDigitale = !valore;
            self.firmaChanged();
        }
        validateComponent();
    }
      
    var validateComponent = function () {
        $timeout(function () {
            console.log("Il form modalitaFirmaForm è:", $scope.modalitaFirmaForm.$valid);
            self.exportValidationComponent({
                valid: $scope.modalitaFirmaForm.$valid
            })
        }, 500)
    }
    
    self.validatingComponent = function () {
        console.log("Il form modalitaFirmaForm è:", $scope.modalitaFirmaForm.$valid);
        self.exportValidationComponent({
            valid: $scope.modalitaFirmaForm.$valid
        })
    }
};
